// extracted by mini-css-extract-plugin
module.exports = {"Container":"ExperimentalSetting_Container__2LAWg","Heading":"ExperimentalSetting_Heading__2_rY-"};